module.exports = __webpack_public_path__ + "static/media/Group 24.5590fdc7.svg";